var _defs, _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoltaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 608.44 259.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{fill:#808184;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#linear-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.87,108.85c-2.37,17.77,6.83,32.42,29.14,53.88,23.13,22.21,54.35,23,62.76,19.89s57-20.15,57-20.15c-27.56,9.68-68-22-80.58-33.23S234,96.41,228.78,80.46c-4.24-12.88,1.62-24.15,4-28Zm37.94-56.4,1-1.43s-.38.51-1,1.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1379.25,
    y1: 612.62,
    x2: 1382.17,
    y2: 612.62,
    gradientTransform: "matrix(-21.88, -31.98, -32.1, 21.8, 50143.42, 30928.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6f0f3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.12.41c6.83-.79,7.23,3.52,7,7.19-.26,5.76-12.07,40-13.65,45.77s-16,54.16-19.43,67.24c-3.06,11.79-12,32.65-15,38.81a70.93,70.93,0,0,0,15.24,4.27c29,2.46,37.18-13.71,44.39-24.5,8.4-12.57,21.26-63.31,23.89-75.08s2.63-22.5-.27-25.38S375,17.79,364.65,6.15C360.07,1,356,.05,353.49.05a6.81,6.81,0,0,0-2.37.36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1340.81,
    y1: 556.85,
    x2: 1343.73,
    y2: 556.85,
    gradientTransform: "matrix(-45.19, 158.68, 159.25, 45.03, -27617.54, -238151.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.5.79c-18.64,6.55-71.18,24.59-90,30.36-10.25,3.12-21.46,13.05-28,23.68-2.66,5.11-6.25,14.8-2.68,25.63a60.79,60.79,0,0,0,2.29,5.79c11-5.22,37.27-14.48,48.34-17.7s57.28-18.93,67.35-22.36c3.9-12.08,11.19-34.07,11.4-38.59.19-3.67-.21-8-7-7.19a8.55,8.55,0,0,1,4.92,0A7.13,7.13,0,0,0,353.65,0a12.77,12.77,0,0,0-4.15.79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1290.59,
    y1: 578.55,
    x2: 1293.51,
    y2: 578.55,
    gradientTransform: "matrix(44.85, 0, 0, -44.68, -57649.35, 25894.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#83b3bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#b8d4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d9e8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e6f0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e4eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#dceaee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#cfe2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bdd7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a5c8d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#88b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#65a1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a9aaa"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "solta_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.11,259.89A31.87,31.87,0,0,1,.29,255.08L0,254.89l2.67-4.58.32.21a25.74,25.74,0,0,0,13.61,4.35c5.06,0,8.6-2.26,8.6-5.49s-2.79-4.68-9-4.83c-9.32-.14-14.73-1.53-14.73-8.2,0-5.42,5-8.92,12.79-8.92A27.26,27.26,0,0,1,29,231.8l.29.18-2.75,4.52-.31-.21a22.93,22.93,0,0,0-12.1-3.89c-4.32,0-7.22,1.59-7.22,3.95s2.45,3.32,9,3.32c9.88,0,14.89,3.36,14.89,10,0,5.08-4.72,10.22-13.72,10.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.82,259.89C62.93,259.89,55,253,55,243.62s7.89-16.18,18.78-16.18c11.1,0,18.85,6.65,18.85,16.18s-7.93,16.27-18.85,16.27m0-27.44c-7.79,0-13.23,4.59-13.23,11.17S66,254.78,73.82,254.78s13.29-4.59,13.29-11.16-5.59-11.17-13.29-11.17"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.72 258.96 118.92 258.96 118.92 228.23 124.32 228.23 124.32 253.93 146.72 253.93 146.72 258.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "179.58 258.96 174.17 258.96 174.17 233.1 161.45 233.1 161.45 228.23 192.3 228.23 192.3 233.1 179.58 233.1 179.58 258.96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.8,259h-5.87l-3.9-7.64H216.58L212.67,259h-5.79l15.68-30.73H226ZM219,246.66h10.61l-5.27-10.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.39,257.4c5.08-.61,6.46-1.69,6.46-7V235c0-3.52-.92-4.44-5.54-4.6v-1.52h11.54L286,252.19l12.46-23.3h11.08v1.52c-4.75.3-6.15,1.23-6.15,6.14v16.86c0,3.22.77,3.83,6.15,4v1.54H291.87V257.4c5.38-.31,6.61-1.07,6.61-5.59V233.63h-.15l-12.24,22.55c-.61,1.14-1.15,2.31-1.76,2.31s-.93-.56-1.85-2.31L270.3,233.63h-.14v20.1c0,2.13,1.07,3.23,5.54,3.67v1.54H261.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.41,248.35h-1.52c-.62-2.91-1.71-4-3.86-4H343.1c-1,0-1.77.78-1.77,2.23v8.51a2.33,2.33,0,0,0,2.39,2.3h3.69c5,0,7.93-1.38,10.09-6H359l-1.38,7.52H330V257.4c4.76-.16,5.69-.77,5.69-2.15V233.32c0-2.45-.7-2.75-5.69-2.91v-1.53H355l1.37,5.66H355c-1.41-2.44-3.24-4.13-9.24-4.13-3.54,0-4.47.61-4.47,2.22v8.67a1.35,1.35,0,0,0,1.54,1.53H347c1.53,0,3.16-1.38,3.86-4.45h1.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.2,233.48c0-2.46-.77-2.91-3.71-3.07v-1.53h13.24c11.86,0,17.1,7.21,17.1,15,0,8.13-6.16,15-19.25,15H378.2V257.4c3.47-.16,4-1.07,4-3.07Zm5.69,20.85c0,1.85,1.24,3.07,3.84,3.07,6.32,0,10.94-4.76,10.94-13.49s-4.62-13.5-10.94-13.5c-2.6,0-3.84,1.23-3.84,3.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428,257.4c3.55-.16,4.31-.44,4.31-3.07V233.48c0-2.61-.76-2.91-4.31-3.07v-1.52h14.62v1.52c-3.84.16-4.62.46-4.62,3.07v20.85c0,2.63.78,2.91,4.62,3.07v1.54H428Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478,228.88c7.55,0,11.69,2.61,11.69,4.6,0,4.9-.46,5.51-1.08,5.51-2.39,0-1.39-8.58-10.46-8.58-7.07,0-10.62,6-10.62,13.43,0,8.95,3.69,14.17,10.78,14.17,6.92,0,10.16-8.27,11.07-8.27s.78.45.78,4c0,2.75-5.47,5.83-11.4,5.83-10.77,0-16.92-6.91-16.92-15,0-9,6.46-15.64,16.16-15.64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.18,247c-1.22,3.53-2.76,7.29-2.76,8.51,0,1.69,1.61,1.92,2.92,1.92v1.54h-8.93V257.4a4.28,4.28,0,0,0,4.08-3l6.77-16.95c1.78-4.45,3.55-9.19,5.39-9.19.77,0,1.31,1.84,1.93,3.37L535,250.8c2.14,5.67,3.14,6.6,5.77,6.6v1.54H528V257.4c2-.16,3.39-.61,3.39-2,0-.91-1.71-4-3.08-8.43Zm9.7-1.53-4.23-12.27h-.16L519,245.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.49,228.88v1.53c-3.39.16-4.16.91-4.16,2.45v20.4c0,3.07.85,3.83,5.62,3.83,12.16,0,10.78-6.59,12.93-6.59.45,0,.69.54.69.92a4.64,4.64,0,0,1-.15,1L588,258.94H560.64V257.4c2.61-.16,4-1.38,4-3.38V232.86c0-1.69-.47-2.29-4-2.45v-1.53Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "240.47 255.87 129.58 93.75 295.76 -19.1 406.65 143.01 240.47 255.87"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "440.14 12.03 389.82 188.69 266.2 153.74 316.51 -22.93 440.14 12.03"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 225.21,
    y: -0.38,
    width: 133.14,
    height: 86.63
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M608.44,233.87a5.88,5.88,0,0,1-5.87,5.9,5.7,5.7,0,0,1-5.71-5.9,5.78,5.78,0,0,1,5.82-5.75,5.64,5.64,0,0,1,5.76,5.75m-10.43,0a4.65,4.65,0,0,0,4.67,4.85,4.58,4.58,0,0,0,4.61-4.85,4.7,4.7,0,0,0-4.61-4.81,4.58,4.58,0,0,0-4.67,4.81m2.83-1.31c0-.78-.15-.78-.57-.94-.58-.26-.27-.47,0-.52a25,25,0,0,1,2.56-.16c1.36,0,2.25.63,2.25,1.57,0,.78-.73,1-.94,1.1-.05,0-.1.1-.05.2a6.35,6.35,0,0,0,1.67,2.35c.22.11.32.26.32.32s-.26.26-.73.26a1.6,1.6,0,0,1-1.42-.79,13.94,13.94,0,0,1-.89-1.51c0-.16-.21-.21-.47-.21s-.37.05-.37.21V235c0,.78.05.78.84,1.09.31.16.26.47,0,.47h-2.77c-.22,0-.37-.31-.11-.42.52-.21.73-.41.73-.94Zm1.31.78c0,.21,0,.21.48.21.78,0,1-.31,1-.94a1,1,0,0,0-.94-1c-.42,0-.53.05-.53.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoltaLogo);
export default __webpack_public_path__ + "static/media/solta_logo.6c24a428e491d0beeeef54d2d0bbd7d9.svg";
export { ForwardRef as ReactComponent };